<template lang="pug">
  .b-change
    TaskStatus._item.old(value="old" :project="createProjectStub(change.info.old, 'old')")
    TaskStatus._item(value="new" :project="createProjectStub(change.info.new, 'new')")
</template>

<script>
import TaskStatus from '@/components/task/TaskStatus.vue';

export default {
  name: 'TaskChangeStatus',
  components: { TaskStatus },
  props: {
    change: Object,
  },
  methods: {
    createProjectStub(status, id) {
      if (typeof status === 'string') {
        const oldStatuses = {
          new: { '@id': id, name: 'Новая', color: '#a5d392' },
          progress: { '@id': id, name: 'В работе', color: '#ffd059' },
          paused: { '@id': id, name: 'Пауза', color: '#cbcbcb' },
          review: { '@id': id, name: 'Проверка', color: '#3680CC' },
          rework: { '@id': id, name: 'На доработку', color: '#7a5e9f' },
          agreement: { '@id': id, name: 'Согласование', color: '#E86863' },
          closed: { '@id': id, name: 'Завершена', color: '#8b8b8b' },
        };

        return {
          taskStatuses: [oldStatuses[status]],
        };
      }

      if (!status || status.name === '' || status.color === '') {
        return { taskStatuses: [] };
      }

      if (typeof status === 'object') {
        return { taskStatuses: [{ ...status, '@id': id }] };
      }

      return { taskStatuses: [] };
    },
  },
};
</script>

<style scoped lang="scss">
  .change {
    display: flex;
    column-gap: 22px;
    row-gap: 10px;
    flex-wrap: wrap;

    &__item {
      //padding: 1px 0;
    }
  }

  .old {
    position: relative;
    opacity: 0.5;

    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: -5px;
      right: -5px;
      height: 1px;
      background: #788CA1;
      display: block;
    }
  }
</style>
